<template>
    <div class="text-center" style="margin-top:50px;">
        <span>{{$t('message.text')}}</span>
        <el-select v-model="selectValue" @change="langChange" placeholder="$t('message.text')">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
        </el-select>
    </div>
</template>
<script>
export default {
    name: 'lang',
    data () {
        return {
            selectValue:'',
            options:[
                {
                value: 'cn',
                label: '中文'
                }, {
                value: 'en',
                label: 'English'
                }
            ]
        };
    },
    created() {
        let that = this;
        that.selectValue = localStorage.lang == undefined?'cn':localStorage.lang
    },
    methods: {
        //语言切换
        langChange(e){
            localStorage.setItem('lang',e);
            this.$i18n.locale = e;
        }            
    }
}
</script>
<style lang="scss" scoped>
 
</style>


// WEBPACK FOOTER //
// src/page/lang/index.vue